<template>
  <div>
    <div class="md:tw-flex tw-justify-between tw-h-[22px]">
      <div class="tw-flex tw-h-[22px]">
        <div
          class="tw-text-[15px] tw-font-semibold tw-text-[#211F58] tw-mr-[12px]"
        >
          {{
            getComponentUiText(
              "app-scan-scanning-title-scan-date-navigation-spinner-1",
            )
          }}
        </div>
        <div
          v-if="isRefreshing && webServicesId === webserviceScanningId"
          class="custom-global-skeleton tw-w-[120px] tw-h-[15px]"
        />
        <div
          v-else-if="isRefreshing && domainId === domainScanningId"
          class="custom-global-skeleton tw-w-[120px] tw-h-[15px]"
        />
        <div v-else class="tw-flex">
          <div
            class="tw-mr-[20px] tw-text-[15px] tw-font-normal tw-text-[#878787]"
          >
            {{
              data.runStatusId === statusScanProgress.SCAN_IN_PROGRESS
                ? getComponentUiText("app-scan-scanning-title-scan-date-now-1")
                : getStartedTime(data.startedAt)
            }}
          </div>
          <div class="tw-mt-[-1px]">
            <button
              v-if="isShowPrev"
              style="cursor: pointer; margin-right: 8px"
              @click.stop="$emit('switch-scan', 'prev')"
            >
              <ArrowLeft />
            </button>
            <button
              v-if="isShowNext"
              style="cursor: pointer"
              @click.stop="$emit('switch-scan', 'next')"
            >
              <ArrowRight />
            </button>
            <button
              v-if="
                isShowSwitchScan && scanTargetType === TYPE_SCHEDULE.webservices
              "
              class="tw-text-[13px] tw-font-normal tw-text-[#387DFF] tw-ml-4"
              @click="downloadDiffScanReport"
            >
              {{
                getComponentUiText(
                  "app-scan-scanning-view-most-recent-scan-navigation-spinner-download-diff-with-current-scan-1",
                )
              }}
            </button>
          </div>
        </div>
      </div>
      <div class="tw-flex tw-gap-4">
        <button
          v-if="isShowSwitchScan"
          class="tw-text-[13px] tw-font-normal tw-text-[#387DFF]"
          @click.stop="$emit('switch-scan', 'latest')"
        >
          {{
            getComponentUiText(
              "app-scan-scanning-view-most-recent-scan-navigation-spinner-1",
            )
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { downloadCSV, getComponentUiText } from "@/utils/utilities";
import { getTimeFromNow } from "@/utils/dateTimeUtils";
import ArrowRight from "@/components/svgs/arrowRight.vue";
import ArrowLeft from "@/components/svgs/arrowLeft.vue";
import { computed, PropType } from "vue";
import type { ScansHistoryWebServicesType } from "@/store/scanning";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { getScanReportDiffWebService } from "@/services/scanning";
import { statusScanProgress, TYPE_SCHEDULE } from "@/utils/constants";
import store from "@/store";
import { Scanning } from "@/services/apiRoutes/routes";

const props = defineProps({
  isShowSwitchScan: {
    type: Boolean,
    required: false,
    default: true,
  },
  isShowPrev: {
    type: Boolean,
    required: true,
  },
  isShowNext: {
    type: Boolean,
    required: true,
  },
  data: {
    type: Object as PropType<
      ScansHistoryWebServicesType["scanReportRuns"][number]
    >,
    required: true,
  },
  scanReportRuns: {
    type: Array,
    required: true,
  },
  scanTargetType: {
    type: String as PropType<keyof typeof TYPE_SCHEDULE>,
    required: false,
    default: TYPE_SCHEDULE.webservices,
  },
  webServicesId: {
    type: String,
    required: true,
  },
  domainId: {
    type: String,
    required: true,
  },
});

const isRefreshing = computed(() => store.state.Scanning.isLoading);

const webserviceScanningId = computed(
  () => store.state.Scanning.webserviceScanningId,
);
const domainScanningId = computed(() => store.state.Scanning.domainScanningId);

const downloadDiffScanReport = async () => {
  let maxScanReportRunId: any = null;

  props.scanReportRuns.forEach((report: any) => {
    if (
      !maxScanReportRunId ||
      parseInt(report.scanReportRunId) > parseInt(maxScanReportRunId)
    ) {
      maxScanReportRunId = report.scanReportRunId;
    }
  });

  try {
    const res = await getScanReportDiffWebService(
      maxScanReportRunId,
      props.data.scanReportRunId,
    );
    if (res) {
      downloadCSV(res, "CurrentDiffScan.csv");
      showSuccessToast(
        getComponentUiText("app-api-scanning-export-csv-success-1"),
      );
    }
  } catch (error: any) {
    showErrorAPI(error, Scanning.getScanReportDiffWebService);
  }
};

defineEmits<{
  (e: "switch-scan", mode: "next" | "prev" | "latest"): void;
}>();

const getStartedTime = (time: any) => {
  return getTimeFromNow(time);
};
</script>
